<template>
  <div>
    <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
      <b-col cols="12" class="mb-3">
        <PageTitle title="Meus contatos" />
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col 
        cols="12" 
        class="d-flex justify-content-center my-4"
      >
        <b-row class="card-video">
          <b-col cols="12">
            <h5>Compartilhar meus links</h5>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <template #append>
                <b-button @click="copyLink()" variant="success">Copiar meu link</b-button>
              </template>
              <b-form-input disabled placeholder="meu link" v-model="urlLinkTree"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col class="mt-4">
            <LinkTreeComponent
              :name="fieldVideo.name"
              :type-link="fieldVideo.type ? fieldVideo.type : LINKTREE.VIDEO"
              :id-type="fieldVideo.id_type"
              :url="fieldVideo.url"
              :status="fieldVideo.status == 1 ? true : false"
              :order="0"
              @save="save($event)"
            />
          </b-col>
          <b-col cols="12" v-if="fieldVideo.status && fieldVideo.url" class="mt-2">
            <h5 class="mb-2 mt-3">{{ fieldVideo.name }}</h5>
            <iframe
              width="100%"
              height="250px"
              :src="`https://www.youtube.com/embed/${getYoutubeVideoUri(fieldVideo.url)}`"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12">
        <h5 class="text-center mt-4">** Clique e segure nos itens para alterar a ordem dos mesmos</h5>
      </b-col>
      <b-col
        v-for="(item, index) in fields"
        :key="index"
        draggable="true"
        class="d-flex justify-content-center mt-2"
        @dragstart="onDragStart(item)"
        @dragover.prevent
        @drop="onDrop(item.order, item.id, item)"
        cols="12"
      >
        <div v-if="item.type !== LINKTREE.VIDEO" class="draggable-item">
          <LinkTreeComponent
            :name="item.name"
            :type-link="item.type"
            :id-type="item.id_type"
            :url="item.url"
            :status="item.status == 1 ? true : false"
            :order="item.order"
            @save="save($event)"
          />
        </div>
      </b-col>

      <b-col class="d-flex justify-content-center mt-4 mb-2">
        <b-button v-if="!isNewComponent" variant="success" @click="isNewComponent = true">
          <i class="fas fa-plus mr-2"></i>
          Inserir Link Personalizado
        </b-button>
      </b-col>

      <b-col
        cols="12"
        v-if="isNewComponent"
        class="d-flex justify-content-center mb-2"
      >
        <b-card  style="width: 35rem;">
          <div><h4 class="text-center">Novo Link</h4></div>
          <div>
            <b-form-group label="Descrição">
              <b-input
                placeholder="Titulo do card"
                v-model="newComponent.name"
              ></b-input>
            </b-form-group>
          </div>
          <div class="mt-3">
            <b-form-group label="Link">
              <b-input
                placeholder="link do card"
                v-model="newComponent.url"
              ></b-input>
            </b-form-group>
          </div>
          <b-row>
            <b-col>
              <b-button variant="danger" block @click="isNewComponent = false">
                Cancelar
              </b-button>
            </b-col>
            <b-col>
              <b-button  block variant="success" @click="newLink()">
                Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LINKTREE from 'Enums/Linktree.js';
import makeToast from '../../../mixins/makeToast';
import { getYoutubeVideoUri } from 'Utils/index.js';
import PageTitle from '../../../components/PageTitle.vue';
import LinkTreeComponent from '@/components/LinkTreeComponent.vue';

export default {
  name: 'CustomizationLinkTree',
  components: { PageTitle, LinkTreeComponent },
  mixins: [makeToast],
  data() {
    return {
      LINKTREE,
      isNewComponent: false,
      loading: false,
      fields: {},
      newComponent: {
        name: "",
        url: ""
      },
      draggedData: null,
      urlLinkTree: null,
      fieldVideo: {
        id_shopkeeper: "",
        id_type: "",
        type:"",
        name: "",
        url: "",
        order: "",
        status: "",
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', 
      [
        'saveLinkTree', 
        'getLinkTree', 
        'updateOrderLinkTree', 
      ]
    ),
    getYoutubeVideoUri,
    get() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      
      this.getLinkTree(this.dadosUsuario.id)
        .then((response) => {
          if (!response.data.data || !response.data.data.length) return;
          this.fields = response.data.data;
          this.fieldVideo = this.fields.find((item)=> item.type == LINKTREE.VIDEO);
          const dataEcommerce = this.fields.find((item)=> item.type == LINKTREE.ECOMMERCE);
          this.urlLinkTree = dataEcommerce.url + '/links';
        }).catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados',
            'danger'
          );
        }).finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save(item) {
      if (!this.validate(item)) return;
      
      const data = {
        id_shopkeeper: this.dadosUsuario.id,
        id_type: item.id_type,
        name: item.name,
        url: item.url,
        order: item.order ? item.order : 0,
        status: item.status,   
      }
    
      this.$store.dispatch('startLoader');
      this.saveLinkTree(data)
        .then(() => {
          this.makeToast('Sucesso', 'Dados salvos com sucesso', 'success');
          if(this.isNewComponent) this.cleanNewComponent();
          this.get()
        }).catch(() => {
            this.makeToast('Erro', 'Houve erro ao salvar os dados, tente novamente', 'danger');
        }).finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    cleanNewComponent() {
      this.newComponent = {
        name: "",
        url: ""
      }
      this.isNewComponent = false;
    },
    newLink() {
      const index = this.fields.length;
      const order = this.fields[index -1].order + 1;

      const newItem = {
        id_type: LINKTREE.CUSTOM,
        name: this.newComponent.name,
        url: this.newComponent.url,
        order: order,
        status: 1,
      }

      this.save(newItem);
    },
    updateOrder(item) {
      this.$store.dispatch('startLoader');

      this.updateOrderLinkTree(item)
        .then(() => {
          this.makeToast('Sucesso', 'Dados salvos com sucesso', 'success');
          this.get();
        }).catch(() => {
            this.makeToast('Erro', 'Houve erro ao alterar a ordem, tente novamente', 'danger');
        }).finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validate(item) { 
      if(!item.name) {
        this.makeToast('Erro', 'Descrição não pode estar vazia', 'danger');
        return false;
      } 
      if(!item.url && item.id_type != LINKTREE.ANDROID && item.id_type != LINKTREE.IOS) {
        this.makeToast('Erro', 'Link não pode estar vazio', 'danger');
        return false;
      }
      return true;
    },
    onDragStart(item) {
      this.draggedData = item;
    },
    onDrop(order, id, item) {
      if (this.draggedData === null || this.draggedData.id === id) return
      
      const data = {
        shopkeeperId: this.dadosUsuario.id,
        idOne: this.draggedData.id,
        orderOne: order,
        idTwo: id,
        orderTwo: this.draggedData.order,
      }
      this.updateOrder(data);
    },
    copyLink() {
      navigator.clipboard.writeText(this.urlLinkTree).then(() => {
        this.makeToast('Sucesso', 'Link copiado com sucesso!', 'success');
      }).catch(err => {
        this.makeToast('Erro', 'Houve um erro ao copiar', 'danger');
      });
    },
  },
};
</script>

<style scoped>

.draggable-item {
  width: 35rem;
  padding: 10px;
  margin: 5px 0;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  cursor: grab;
}

.draggable-item:hover {
  background-color: #e0e0e0;
}

.card-video {
  width: 35rem;
}

@media screen and (max-width: 590px) {
  .draggable-item {
    width: 21rem;
  }
  .card-video {
  width: 21rem;
}
}
</style>
